module.exports = __webpack_public_path__ + "img/bg.50068b15.png";